import {
  ADD_PUBLISH,
  ADD_PUBLISH_SUCCESS,
  ADD_PUBLISH_FAILED,
  FETCH_PUBLISH,
  FETCH_PUBLISH_SUCCESS,
  FETCH_PUBLISH_FAILED,
  CLEAR_PUB_ERROR,
  ADD_PUBLISH_WEBSITE,
  ADD_PUBLISH_WEBSITE_SUCCESS,
  ADD_PUBLISH_WEBSITE_FAILED,
  FETCH_PUBLISH_WEBSITE,
  FETCH_PUBLISH_WEBSITE_SUCCESS,
  FETCH_PUBLISH_WEBSITE_FAILED,
  ADD_PRIVATE_PROP_PUBLISH,
  ADD_PRIVATE_PROP_PUBLISH_SUCCESS,
  ADD_PRIVATE_PROP_PUBLISH_FAILED,
  FETCH_PRIVATE_PROP_PUBLISH,
  FETCH_PRIVATE_PROP_PUBLISH_SUCCESS,
  FETCH_PRIVATE_PROP_PUBLISH_FAILED,
  SYNC_TO_PROP24,
  SYNC_TO_PROP24_SUCCESS,
  SYNC_TO_PROP24_FAILED,
  SYNC_TO_PRIVATEPROP,
  SYNC_TO_PRIVATEPROP_SUCCESS,
  SYNC_TO_PRIVATEPROP_FAILED,
  SYNC_TO_WEBSITE,
  SYNC_TO_WEBSITE_SUCCESS,
  SYNC_TO_WEBSITE_FAILED
} from "../store/types";
import { cloud_function_server_url } from "config";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

export const fetchPublication = () => (dispatch) => (firebase) => {
  const { publicationRef } = firebase;
  console.log(axios);
  dispatch({
    type: FETCH_PUBLISH,
    payload: false
  });

  try {
    const joomlaEndpoint =
      "https://api-prop.plum.systems/api/index.php/v1/content/articles";
    const joomlaConfig = {
      method: "get",
      maxBodyLength: Infinity,
      url: joomlaEndpoint,
      headers: {
        "X-Joomla-Token":
          "c2hhMjU2OjUwOmE1MmY1MjcwOWU1MjMwYTNjZWQwZGQ2NTlmY2Q3MDVkM2Q4YWU5YmRjMzFjYjYzMGIwMTVlMDY5MjExYjViZDU=",
        Cookie: "/JSESSIONID=[^;]+/",
        "Content-Type": "application/json"
      }
    };

    const response = axios(joomlaConfig);
    console.log("this is the responce", response);
  } catch (error) {
    dispatch({
      type: FETCH_PUBLISH_FAILED,
      payload: error
    });
    console.log("fetch publication : ", error);
  }
};
export const clearPublishErrors = () => (dispatch) => {
  dispatch({
    type: CLEAR_PUB_ERROR,
    payload: null
  });
};

const convertListingImagesToObject = (images) =>
  new Promise((resolve, reject) => {
    let imageArray = Object.values(images);
    let base64Array = [];

    for (let index = 0; index < imageArray.length; index++) {
      const image = imageArray[index];

      convertImageToBase64(image).then((base64Image) => {
        let imageData = splitBase64(base64Image);

        let object = {
          image_intro: imageData.data,
          image_intro_alt: `image ${index}`,
          float_intro: "",
          image_intro_caption: "view",
          image_fulltext: "",
          image_fulltext_alt: "",
          float_fulltext: "",
          image_fulltext_caption: "",
          bytes: imageData.data,
          mimeContentType: imageData.mimeType,
          caption: `image ${index}`
          // isFloorPlan: false
        };

        base64Array.push(object);

        if (index === imageArray.length - 1) {
          resolve(base64Array);
        }
      });
    }
  });
export const publishToWeb = (data) => (dispatch) => async (firebase) => {
  const { singleListingRef } = firebase;
  dispatch({
    type: ADD_PUBLISH_WEBSITE,
    payload: false
  });
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      alias: data?.web_Ref_No ? data?.web_Ref_No : data?.web_Ref_No,
      catid: data?.selectedArea.wsCatId ? data?.selectedArea.wsCatId : 10,
      created_by: data?.userdetials?.wsAgentId
        ? data?.userdetials?.wsAgentId
        : 65,
      title: data?.title ? data?.title : data?.marketingHeading,
      articletext: data?.description ? data?.description : "",
      version: 1,
      metakey: data?.tags ? data?.tags : "",
      metadesc: data?.additionalNotes ? data?.additionalNotes : "",
      metadata: data?.pspmnotes ? data?.pspmnotes : "",
      featured: 0,
      language: data?.language ? data?.language : "*",
      text: data?.text ? data?.text : data?.description,
      parking: data?.openParkingBays ? data?.openParkingBays : "",
      "covered-parking": data?.coveredParking ? data?.coveredParking : "",
      area: data?.landSize ? data?.landSize : "",
      price: data?.price ? data?.price : "",
      "price-for-sale": data?.price ? data?.price : "",
      address: data?.address?.address ? data?.address?.address : "",
      latlong:
        data?.address?.coords?.lat && data?.address?.coords?.lng
          ? data?.address?.coords?.lat + "," + data?.address?.coords?.lng
          : "",
      longitude: data?.address?.coords?.lng ? data?.address?.coords?.lng : "",
      location: data?.location ? data?.location : "",
      "rent-or-sale":
        data.type === "tolet" ||
          data.type.toLowerCase().includes("to let") ||
          data.type.toLowerCase().includes("rental")
          ? "Rental"
          : "Sale",
      currency: "ZAR",
      "value-of-price": "month",
      "value-of-area": "m2",
      "plot-size": data?.standSize ? data?.standSize : "",
      note: data?.additionalNotes ? data?.additionalNotes : "",
      "security-information": data?.security_information
        ? data?.security_information
        : "",
      "air-condition": data?.airCondition ? data?.airCondition : false,
      "sole-mandate": data?.typeOfMandate ? data?.typeOfMandate : "",
      description: data?.description ? data?.description : "",
      "property-location": data?.location ? data?.location : "",
      "image-count": data?.imageCount,
      "position-map-y": data?.address?.coords?.lat
        ? data?.address?.coords?.lat
        : "",
      "power-amps": data?.powerAmps ? data?.powerAmps : "",
      "video-id": data?.videoId ? data?.videoId : "",
      "retail-price": data?.retailPrice ? data?.retailPrice : 0,
      "size-of-land": data?.landSize ? data?.landSize : "",
      "floor-size": data?.floorSize ? data?.floorSize : "",
      "building-height": data?.buildingHieght ? data?.buildingHieght : "0",
      "floor-loading-capacity": data?.floorLoadingCapacity
        ? data?.floorLoadingCapacity
        : "",
      "office-space-size": data?.officeSize ? data?.officeSize : "",
      "office-space-total-price": data?.officeToWarehouseRatio
        ? data?.officeToWarehouseRatio
        : "",
      "virtual-tour": data?.eyespy360Url ? data?.eyespy360Url : "",
      "retail-size": data?.retailSize ? data?.retailSize : "",
      "warehouse-size": data?.factorySize ? data?.factorySize : "",
      "yard-size": data?.yardSize ? data?.yardSize : "",
      "position-map-x": data?.address?.coords?.lng
        ? data?.address?.coords?.lng
        : "",
      "building-size": data?.gla ? data?.gla : "",
      "availability-of-amps": data?.isThreePhase ? data?.isThreePhase : "",
      "eaves-height": data?.heightToEaves ? data?.heightToEaves : "",
      "amount-of-roller-shutter-doors": data?.heightOfRollerShutterDoors
        ? data?.heightOfRollerShutterDoors
        : "",
      phase: data?.isThreePhase ? data?.isThreePhase : "",
      "physical-address": data?.address?.address ? data?.address?.address : "",
      "type-of-title": "",
      "sale-price": data?.price ? data?.price : "",
      "gross-monthly-rental": data?.grossmonthlyRental
        ? data?.grossmonthlyRental
        : "",
      "fire-systems": data?.fireSystems ? data?.fireSystems : "no",
      "alternative-water-supply": data?.alternativeWaterSupply
        ? data?.alternativeWaterSupply
        : "",
      "alternative-power-supply": data?.alternativePowerSupply
        ? data?.alternativePowerSupply
        : "",
      webref: data?.web_Ref_No ? data?.web_Ref_No : "",
      status: data?.status ? data?.status : "Active",
      branch: data?.selectedArea?.selectedBranchName
        ? data?.selectedArea?.selectedBranchName
        : "",
      "area-name": data?.selectedArea?.areaName
        ? data?.selectedArea?.areaName
        : "",
      "area-p24-id": data?.selectedArea?.p24?.suburbId
        ? data?.selectedArea?.p24?.suburbId
        : "",
      countryname: data?.address?.country ? data?.address?.country : "",
      countryid: 1,
      provincename: data?.selectedArea?.p24?.provinceName
        ? data?.selectedArea?.p24?.provinceName
        : "",
      provinceid: data?.selectedArea?.p24?.provinceId
        ? data?.selectedArea?.p24?.provinceId
        : "",
      cityname: data?.address?.city ? data?.address?.city : "",
      cityid: data?.selectedArea?.p24?.cityId
        ? data?.selectedArea?.p24?.cityId
        : "",
      geopoint:
        data?.address?.coords?.lat && data?.address?.coords?.lng
          ? data?.address?.coords?.lat + "," + data?.address?.coords?.lng
          : "",
      typeofproperty: data?.typeOfProperty ? data?.typeOfProperty : "",
      usagetype: data?.industrialCommercial ? data?.industrialCommercial : "",
      ggg: data?.capx ? data?.capx : "",
      pdfurl: data?.BrochureUrl ? data?.BrochureUrl : "",
      poa: "No",
      images: {
        image_intro: data?.images?.Image0
          ? data?.images?.Image0
          : "https://storage.googleapis.com/api-img/" +
          data?.web_Ref_No +
          "/Images/Image0.jpeg",
        image_intro_alt: "",
        float_intro: "",
        image_intro_caption: "",
        image_fulltext: data?.images?.Image1
          ? data?.images?.Image1
          : "https://storage.googleapis.com/api-img/" +
          data?.web_Ref_No +
          "/Images/Image1.jpeg",
        image_fulltext_alt: "",
        float_fulltext: "",
        image_fulltext_caption: ""
      }
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoapiweb`, requestOptions)
      .then((response) => {
        response;
        dispatch({
          type: ADD_PUBLISH_WEBSITE_SUCCESS,
          payload: response
        });

        return response.json();
      })
      .then((result) => {
        singleListingRef(data.id).update({
          publishedAPIWeb: true,
          wsListingId: result.data.id
        });
      })
      .catch((error) => console.error(error));
  } catch (error) {
    console.log("error in publish to  Api web", error.message);
    dispatch({
      type: ADD_PUBLISH_WEBSITE_FAILED,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`
    });
  }
};






export const updateListingStatusProperty24 = (ListingId, Status) => (dispatch) => async (firebase) => {



}


const parseAddressDescription = (description) => {
  let country = "SouthAfrica"; // Default without space
  let province = "";
  let city = "";
  let suburb = "";

  if (description) {
    const parts = description.split(",").map((part) => part.trim());

    // Check if first part is a country indicator
    if (parts[0] === "South Africa" || parts[0] === "RSA") {
      country = parts[0].replace(/\s+/g, ""); // Remove spaces from country

      if (parts.length >= 4) {
        province = parts[1].replace(/\s+/g, "");
        city = parts[2].replace(/\s+/g, "");
        suburb = parts[3].replace(/\s+/g, "");
      } else if (parts.length === 3) {
        province = parts[1].replace(/\s+/g, "");
        city = parts[2].replace(/\s+/g, "");
      } else if (parts.length === 2) {
        province = parts[1].replace(/\s+/g, "");
      }
    } else {
      // Handle cases where country might not be at the beginning
      if (parts.length >= 3) {
        suburb = parts[0].replace(/\s+/g, "");
        city = parts[1].replace(/\s+/g, "");
        province = parts[2].replace(/\s+/g, "");
      } else if (parts.length === 2) {
        suburb = parts[0].replace(/\s+/g, "");
        city = parts[1].replace(/\s+/g, "");
      } else if (parts.length === 1) {
        suburb = parts[0].replace(/\s+/g, "");
      }
    }
  }

  return { country, province, city, suburb };
};



function cleanText(text) {
  if (!text) return "";
  // Remove all non-printable characters (ASCII 0–31 except 10 (LF) and 13 (CR))
  return text.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, "").trim();
}


export const updatePrivatePropStatus = (data, token) => (dispatch) => async (firebase) => {
  const { singleListingRef } = firebase;
  dispatch({
    type: ADD_PRIVATE_PROP_PUBLISH,
    payload: false
  });
  const parser = new XMLParser();


  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");

    const raw = `
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
  <soapenv:Header/>
  <soapenv:Body>
   <ListingStatusUpdate xmlns="http://tempuri.org/">
    <BranchId>${data.BranchPPId || ""}</BranchId> 
    <PropertyId>${data.id || ""}</PropertyId> 
    <ListingType>${data.type === "tolet" ||
        data.type.toLowerCase().includes("to let") ||
        data.type.toLowerCase().includes("rental")
        ? "Rental"
        : "Sale"
      }</ListingType> 
    <PropertyStatus>${data.PPStatus}</PropertyStatus>

      <tem:Token>
        <tem:Digest>${token.Digest}</tem:Digest>
        <tem:UserName>${token.UserName}</tem:UserName>
        <tem:StampTime>${token.StampTime}</tem:StampTime>
        <tem:Expires>${token.Expires}</tem:Expires>
        <tem:UID>${token.UID}</tem:UID>
      </tem:Token>
   </ListingStatusUpdate>
  </soapenv:Body>
</soapenv:Envelope>
`;


    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoPrivateprop`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log("result", result);

        if (result.errors || result.error) {
          let errorMessage = ``;

          if (result.errors) {
            errorMessage = parseApiErrors(result.errors);
          }

          if (result.error) {
            errorMessage = result.error;
          }

          dispatch({
            type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
            payload: `Sorry an error has occured ,\n ${errorMessage}`
          });
          return;
        }

        const jsonObj = parser.parse(result);
        const output =
          jsonObj.rawResponse["soap:Envelope"]["soap:Body"]["ListingStatusUpdateResponse"][
          "ListingStatusUpdateResult"
          ];

        if (output === "Successful") {
          dispatch({
            type: ADD_PRIVATE_PROP_PUBLISH_SUCCESS,
            payload: output
          });
          singleListingRef(data.id).update({
            privateprop: true,
          });
        }



      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
          payload: error
        });
      });
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
      payload: error
    });
  }
};

export const getPrivatePropStatus = (data, token) => (dispatch) => async (firebase) => {
  const { singleListingRef } = firebase;
  dispatch({
    type: ADD_PRIVATE_PROP_PUBLISH,
    payload: false
  });
  const parser = new XMLParser();


  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");

    const raw = `
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
  <soapenv:Header/>
  <soapenv:Body>
<tem:GetListingStatusVerbose >
    <BranchId>${data.BranchPPId || ""}</BranchId> 
    <PropertyId>${data.id || ""}</PropertyId>  
      <tem:Token>
        <tem:Digest>${token.Digest}</tem:Digest>
        <tem:UserName>${token.UserName}</tem:UserName>
        <tem:StampTime>${token.StampTime}</tem:StampTime>
        <tem:Expires>${token.Expires}</tem:Expires>
        <tem:UID>${token.UID}</tem:UID>
      </tem:Token>
</tem:GetListingStatusVerbose >
  </soapenv:Body>
</soapenv:Envelope>
`;


    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoPrivateprop`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log("result", result);

        if (result.errors || result.error) {
          let errorMessage = ``;

          if (result.errors) {
            errorMessage = parseApiErrors(result.errors);
          }

          if (result.error) {
            errorMessage = result.error;
          }

          dispatch({
            type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
            payload: `Sorry an error has occured ,\n ${errorMessage}`
          });
          return;
        }

        const jsonObj = parser.parse(result);
        const output =
          jsonObj.rawResponse["soap:Envelope"]["soap:Body"]["ListingStatusUpdateResponse"][
          "ListingStatusUpdateResult"
          ];

        if (output === "Successful") {
          dispatch({
            type: ADD_PRIVATE_PROP_PUBLISH_SUCCESS,
            payload: output
          });
          singleListingRef(data.id).update({
            privateprop: true,
          });
        }



      })
      .catch((error) => {
        console.error(error);
        dispatch({
          type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
          payload: error
        });
      });
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
      payload: error
    });
  }
};

export const publishToprivateprop = (data, token) => (dispatch) => async (firebase) => {
  const { singleListingRef } = firebase;
  dispatch({
    type: ADD_PRIVATE_PROP_PUBLISH,
    payload: false
  });
  const parser = new XMLParser();

  function mapMandateType({ typeOfMandate }) {
    const mapping = {
      exclusive: "FullMandate",
      open: "OpenMandate",
      joint: "HouseShare",
      sole: "FullMandate"
    };

    return mapping[typeOfMandate] || "";
  }
  const addressParts = parseAddressDescription(data.selectedArea?.areaName);
  console.log("addressParts", addressParts);
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");

    const raw = `
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
  <soapenv:Header/>
  <soapenv:Body>
    <tem:UpdateListing>
      <tem:ListingImport>
        <tem:PropertyId>${data.web_Ref_No || ""}</tem:PropertyId>
        <tem:BranchId>${data.BranchPPId || ""}</tem:BranchId>

        <tem:Category>
          <tem:Category>${data.pppropertyType || "Commercial"}</tem:Category>
        </tem:Category>

        ${data.typeOfMandate
        ? `<tem:MandateType>${data.typeOfMandate === "exclusive" || data.typeOfMandate === "sole"
          ? "FullMandate"
          : data.typeOfMandate === "open"
            ? "OpenMandate"
            : data.typeOfMandate === "joint"
              ? "HouseShare"
              : null
        }</tem:MandateType>`
        : ""}

        ${data.address?.streetName ? `<tem:StreetName>${data.address.streetName}</tem:StreetName>` : ""}
        ${data.address?.streetNumber ? `<tem:StreetNumber>${data.address.streetNumber}</tem:StreetNumber>` : ""}
        ${data.address?.complexName ? `<tem:ComplexName>${data.address.complexName}</tem:ComplexName>` : ""}
        ${data.address?.unitNumber ? `<tem:UnitNumber>${data.address.unitNumber}</tem:UnitNumber>` : ""}

        <tem:SuburbId>${Number(data.selectedArea?.pp?.suburbId) || 0}</tem:SuburbId>

        ${data.marketingHeading ? `<tem:Headline>${cleanText(data.marketingHeading)}</tem:Headline>` : ""}
        ${data.description ? `<tem:Description>${cleanText(data.description)}</tem:Description>` : ""}

        <tem:Price>${data.type === "tolet" || data.type.toLowerCase().includes("to let")
        ? Number(data?.grossmonthlyRental || 0)
        : Number(data.price || 0)
      }</tem:Price>

        ${data.salesPricePresentation ? `<tem:SalesPricePresentation>${data.salesPricePresentation}</tem:SalesPricePresentation>` : ""}
        ${data.deposit ? `<tem:Deposit>${data.deposit}</tem:Deposit>` : ""}

        ${data.startPublishing ? `<tem:ListingDate>${data.startPublishing}</tem:ListingDate>` : ""}
        ${data.expiryDate ? `<tem:ExpiryDate>${data.expiryDate}</tem:ExpiryDate>` : ""}
        ${(data.availableFrom && data.availableFrom !== "Negotiable" && data.availableFrom !== "To Be Decided") ? `<tem:AvailableFrom>${data.availableFrom}</tem:AvailableFrom>` : ""}

        ${data.userdetials?.PPagentId ? `<tem:AgentId>${data.userdetials.PPagentId}</tem:AgentId>` : ""}

    <tem:PhotoUrls>
  ${Array.isArray(data.images)
        ? data.images
          .map((_, index) => {
            // File name starts from 0
            const fileName = `${Object.keys(data.images)[index]}.jpeg`;
            console.log('fileName', fileName)

            // Build public GCS URL
            const publicUrl = `https://storage.googleapis.com/api-nexus-f7bcd.appspot.com/Listings/${data.web_Ref_No}/Images/${fileName}`;

            // Escape XML special chars
            const escapedImg = publicUrl
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&apos;");

            return `<tem:string>${escapedImg}</tem:string>`;
          })
          .join("\n  ")
        : Object.values(data.images)
          .map((_, index) => {
            // File name starts from 0
            const fileName = `${Object.keys(data.images)[index]}.jpeg`;

            console.log('fileName', fileName)

            // Build public GCS URL
            const publicUrl = `https://storage.googleapis.com/api-nexus-f7bcd.appspot.com/Listings/${data.web_Ref_No}/Images/${fileName}`;

            const escapedImg = publicUrl
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&apos;");

            return `<tem:string>${escapedImg}</tem:string>`;
          })
          .join("\n  ")
      }
</tem:PhotoUrls>

        <tem:ListingType>${data.type === "tolet" ||
        data.type.toLowerCase().includes("to let") ||
        data.type.toLowerCase().includes("rental")
        ? "Rental"
        : "Sale"
      }</tem:ListingType>

        <tem:PropertyStatus>${data.PPStatus ? data.PPStatus : data.type === "tolet" ||
        data.type.toLowerCase().includes("to let") ||
        data.type.toLowerCase().includes("rental")
        ? "ToLet"
        : data.type.toLowerCase().includes("sale")
          ? "ForSale"
          : "ForSale"
      }</tem:PropertyStatus>

        <tem:Attributes>
          <tem:Attribute>
            <tem:AttributeType>${data.propertyType === "Land" ? "LandType" : "BusinessType"}</tem:AttributeType>
            <tem:Value>${data.propertyType === "Land" ? "Commercial Land" : data.industrialCommercial || ""}</tem:Value>
          </tem:Attribute>

          ${data.bathrooms ? `<tem:Attribute><tem:AttributeType>Bathrooms</tem:AttributeType><tem:Value>${data.bathrooms}</tem:Value></tem:Attribute>` : ""}

          ${data.floorSize ? `<tem:Attribute><tem:AttributeType>FloorArea</tem:AttributeType><tem:Value>${data.floorSize}</tem:Value></tem:Attribute>` : ""}

          ${data.landSize && data.landSize !== "None"
        ? `<tem:Attribute><tem:AttributeType>LandArea</tem:AttributeType><tem:Value>${data.landSize}</tem:Value></tem:Attribute>`
        : ""}

          <tem:Attribute>
            <tem:AttributeType>Carports</tem:AttributeType>
            <tem:Value>0</tem:Value>
          </tem:Attribute>

          ${data.openingParkingBays
        ? `<tem:Attribute><tem:AttributeType>Parking</tem:AttributeType><tem:Value>${data.openingParkingBays}</tem:Value></tem:Attribute>`
        : ""}

          <tem:Attribute>
            <tem:AttributeType>ElectrictyIncluded</tem:AttributeType>
            <tem:Value>No</tem:Value>
          </tem:Attribute>

          <tem:Attribute>
            <tem:AttributeType>Aircon</tem:AttributeType>
            <tem:Value>${data.airConditioning ? "Yes" : "No"}</tem:Value>
          </tem:Attribute>

          <tem:Attribute>
            <tem:AttributeType>Alarm</tem:AttributeType>
            <tem:Value>No</tem:Value>
          </tem:Attribute>

          <tem:Attribute>
            <tem:AttributeType>HandicapAvailable</tem:AttributeType>
            <tem:Value>No</tem:Value>
          </tem:Attribute>

          <tem:Attribute>
            <tem:AttributeType>AccessGate</tem:AttributeType>
            <tem:Value>No</tem:Value>
          </tem:Attribute>

          ${data.security
        ? `<tem:Attribute><tem:AttributeType>SecurityPost</tem:AttributeType><tem:Value>${data.security}</tem:Value></tem:Attribute>`
        : ""}

          <tem:Attribute>
            <tem:AttributeType>Storage</tem:AttributeType>
            <tem:Value>No</tem:Value>
          </tem:Attribute>

          ${data.monthlyRates
        ? `<tem:Attribute><tem:AttributeType>Rates</tem:AttributeType><tem:Value>${data.monthlyRates}</tem:Value></tem:Attribute>`
        : ""}

          ${data.monthlyLevy
        ? `<tem:Attribute><tem:AttributeType>Levies</tem:AttributeType><tem:Value>${data.monthlyLevy}</tem:Value></tem:Attribute>`
        : ""}
        </tem:Attributes>

        <tem:HideStreetName>${data.locationType !== "address"}</tem:HideStreetName>
        <tem:HideStreetNo>${data.locationType !== "address"}</tem:HideStreetNo>
        <tem:HideComplexName>${data.locationType !== "address"}</tem:HideComplexName>
        <tem:HideUnitNumber>${data.locationType !== "address"}</tem:HideUnitNumber>

        ${data.type === "tolet" || data.type.toLowerCase().includes("rental") ? "<tem:RentalPriceType>PerM2</tem:RentalPriceType>" : ""}

        ${data.locationType
        ? `<tem:XCoordinate>${data.locationType === "address"
          ? data?.address?.coords.lng
          : data.selectedArea?.p24?.geoPoint?.longitude
        }</tem:XCoordinate>
               <tem:YCoordinate>${data.locationType === "address"
          ? data?.address?.coords.lat
          : data.selectedArea?.p24?.geoPoint?.latitude
        }</tem:YCoordinate>`
        : ""}
      </tem:ListingImport>

      <tem:Token>
        <tem:Digest>${token.Digest}</tem:Digest>
        <tem:UserName>${token.UserName}</tem:UserName>
        <tem:StampTime>${token.StampTime}</tem:StampTime>
        <tem:Expires>${token.Expires}</tem:Expires>
        <tem:UID>${token.UID}</tem:UID>
      </tem:Token>
    </tem:UpdateListing>
  </soapenv:Body>
</soapenv:Envelope>
`;


    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/publishtoPrivateprop`, requestOptions)
      .then(async (response) => {
        const result = await response.json(); // Always JSON now
        console.log("result", result);

        if (!response.ok || result.success === false) {
          let errorMessage = "";

          if (result.error) {
            errorMessage = result.error;
          } else if (result.errors) {
            errorMessage = result.rawResponse;
          } else {
            errorMessage = "An unknown error occurred while publishing.";
          }

          dispatch({
            type: ADD_PUBLISH_FAILED,
            payload: `Sorry, an error has occurred.\n${errorMessage}`
          });
          return;
        } else {
          // ✅ Success case
          const jsonObj = parser.parse(result.rawResponse);
          const output =
            jsonObj["soap:Envelope"]["soap:Body"]["UpdateListingResponse"][
            "UpdateListingResult"
            ];

          if (output.toLowerCase().includes("success")) {
            dispatch({
              type: ADD_PRIVATE_PROP_PUBLISH_SUCCESS,
              payload: output
            });

            singleListingRef(data.id).update({
              privateprop: true,
            });
          } else {
            // Handle unexpected success responses that aren't clear
            dispatch({
              type: ADD_PUBLISH_FAILED,
              payload: `Unexpected response: ${output}`
            });
          }
        }


      })
      .catch((error) => {
        console.error("Network error:", error);
        dispatch({
          type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
          payload: `Network error: ${error.message}`
        });
      });

  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_PRIVATE_PROP_PUBLISH_FAILED,
      payload: error
    });
  }
};

function splitBase64(base64String) {
  const [metadata, data] = base64String.split(",");
  const mimeType = metadata.match(/data:([^;]+);base64/)[1];
  return { mimeType, data };
}

function convertImageToBase64(url) {
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject("Error reading file.");
        reader.readAsDataURL(blob);
      });
    });
}

const convertListingImagesToProp24Object = async (images) => {
  const imageArray = Object.values(images);

  const base64Array = await Promise.all(
    imageArray.map(async (image, index) => {
      const base64Image = await convertImageToBase64(image);
      const imageData = splitBase64(base64Image);

      return {
        bytes: imageData.data,
        mimeContentType: imageData.mimeType,
        caption: `image ${index}`,
        isFloorPlan: false
      };
    })
  );

  return base64Array;
};


function parseApiErrors(errors) {
  const messages = [];

  for (const path in errors) {
    // Split the JSON path by '.' and take the last part as the field name
    const parts = path.split(".");
    const fieldName = parts[parts.length - 1].replace(/\$/g, ""); // remove $ if present

    // Join all error messages for that field
    const fieldErrors = errors[path].join("; ");

    // Build user-friendly message
    messages.push(`${fieldName} is incorrect`);
  }

  return messages;
}

export const publishto24prop =
  (data, agentId) => (dispatch) => async (firebase) => {
    const { singleListingRef, api } = firebase;
    dispatch({
      type: ADD_PUBLISH,
      payload: false
    });

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "text/plain");
      myHeaders.append(
        "Authorization",
        `Basic ${btoa("apiproperties@plum.systems:!@#$S7t11dbN9pa7")}`
      );


      console.log("data?.streetNumber", data?.streetNumber);
      console.log('data.P24Status', data.P24Status);
      console.log('data.P24expiryDate', data.P24expiryDate);
      console.log("data?.address.address", data?.address.address);

      const raw = JSON.stringify({
        agencyId: data.agencyId, //Has input
        contactAgentIds: [Number(agentId) ? Number(agentId) : agentId], //Has input
        listingType:
          data.type === "tolet" || data.type.includes("To Let")
            ? "Rental"
            : "Sale", //Has input
        listingNumber: data?.ListingId || null, // For updates //Has input
        status: data.P24Status ?? "NewListing", //Has input
        price:
          data.type === "tolet" || data.type.includes("To Let")
            ? Number(data?.grossmonthlyRental)
            : Number(data.price), //Has input
        isPOA: data?.poa || false, //Has input
        listingVisibility: data?.listingVisibility //Has input
          ? data?.listingVisibility
          : "Public",
        expiryDate: data?.P24expiryDate ? data?.P24expiryDate : data?.expiryDate ? data?.expiryDate
          : new Date(new Date().setMonth(new Date().getMonth() + 3))
            .toISOString()
            .split("T")[0]
            .replace(/(\d{4})-(\d{2})-(\d{2})/, "$1-$3-$2"), //Has input
        description: data?.description ? data?.description : "", //Has input
        descriptionHeader: data?.marketingHeading
          ? data?.marketingHeading
          : null, //Has input
        showDays: data?.showDays ? data?.showDays : null,
        imageLinks: data.images, //Has input
        propertyInfo: {
          showLocation: data?.showLocation ? data?.showLocation : false,
          age: data?.age ? data?.age : null,
          suburbId: data?.selectedArea?.p24?.suburbId ? data?.selectedArea?.p24?.suburbId : 455,
          municipalRatesAndTaxes: {
            amount: data?.municipalRatesAndTaxes
              ? data?.municipalRatesAndTaxes
              : 0,
            unit: data?.municipalRatesAndTaxesUnit
              ? data?.municipalRatesAndTaxesUnit
              : "PerSquareMetre"
          },
          monthlyLevy: {
            amount: Number(data?.seller.monthlyLevyPerSQM)
              ? Number(data?.seller.monthlyLevyPerSQM)
              : 0,
            unit: "PerSquareMetre"
          },
          streetNumber: data?.streetNumber ? data?.streetNumber : null,
          streetName:
            data.locationType === "address" && data?.address.address
              ? data?.address.address
              : null,
          standNumber: data?.address.standNumber
            ? data?.address.standNumber
            : null,
          sourceReference: data?.web_Ref_No ? data?.web_Ref_No : null,
          geographicLocation: {
            longitude:
              data.locationType === "address"
                ? data?.address?.coords.lng
                : data.selectedArea.p24.geoPoint.longitude,
            latitude:
              data.locationType === "address"
                ? data?.address?.coords.lat
                : data.selectedArea.p24.geoPoint.latitude
          },
          propertyDescription: {
            propertyDescriptionType: 1,
            deedsOffice: data?.deedsoffice,
            township: data?.township ? data?.township : "",
            erfNumber: Number(data?.erf) ? Number(data?.erf) : 123456,
            portion: data?.portion ? data?.portion : "",
            registrationDivision: data?.registrationDivision
              ? data?.registrationDivision
              : "",
            farmNumber: Number(data?.farmNumber)
              ? Number(data?.farmNumber)
              : 123,
            farmName: data?.farmName ? data?.farmName : "",
            holdingName: data?.holdingName ? data?.holdingName : "",
            holdingNumber: Number(data?.holdingNumber)
              ? Number(data?.holdingNumber)
              : 123,
            schemeName: data?.schemeName ? data?.schemeName : "",
            schemeNumber: Number(data?.schemeNumber)
              ? Number(data?.schemeNumber)
              : 123,
            unitNumber: data?.unitNumber ? data?.unitNumber : "",
            exclusiveUseAreaNumber: data?.exclusiveUseAreaNumber
              ? data?.exclusiveUseAreaNumber
              : ""
          },
          erf: {
            size: data?.landSize ? data?.landSize : 0,
            areaUnit: data?.erf?.areaUnit ? data?.erf?.areaUnit : "SquareMetres"
          },
          floorArea: {
            size: data?.floorSize ? data?.floorSize : 0,
            areaUnit: data?.areaUnit ? data?.areaUnit : "SquareMetres"
          },
          propertyTypeId: data.p24propertyType ? data.p24propertyType : 12,
          specialLevy: data?.specialLevy ? data?.specialLevy : null,
          floorNumber: (data.address.floorNumber && typeof data?.address.floorNumber === 'number') ? data?.address.floorNumber : null,
          coverage: data?.coverage ? data?.coverage : null,
          pricePerParkingBay: data?.pricePerParkingBay
            ? data?.pricePerParkingBay
            : null,
          zoneType: data?.zoneType ? data?.zoneType : null
        },
        rentalInfo: {
          rentalRate: "Month",
          leasePeriod: data.leasePeriod ? data.leasePeriod : null
        },
        propertyFeatures: {
          bedrooms: data.bedrooms ? data.bedrooms : null,
          bathrooms: {
            bathrooms: data.bathrooms ? data.bathrooms : null,
            description: "",
            cleaningService: null,
            unisexBathrooms: null,
            communalBathrooms: null,
            executiveBathrooms: null,
            inUnitBathrooms: null
          },

          parking: {
            parkingSpaces: data?.parkingSpaces ? data?.parkingSpaces : null,
            parkingSpacesDescription: data?.parkingSpacesDescription
              ? data?.parkingSpacesDescription
              : "",
            parkingBayNumber: data?.parkingBayNumber
              ? data?.parkingBayNumber
              : null,
            carport: data?.carport ? data?.carport : null,
            doubleParking: data?.doubleParking ? data?.doubleParking : null,
            onStreetParking: data?.onStreetParking
              ? data?.onStreetParking
              : null,
            secureParking: data?.secureParking ? data?.secureParking : null,
            shadeNetCoveredParking: data?.shadeNetCoveredParking
              ? data?.shadeNetCoveredParking
              : null,
            singleParking: data?.singleParking ? data?.singleParking : null,
            tandemParking: data?.tandemParking ? data?.tandemParking : null,
            tripleParking: data?.tripleParking ? data?.tripleParking : null,
            undergroundParking: data?.undergroundParking
              ? data?.undergroundParking
              : null,
            visitorsParking: data?.visitorsParking
              ? data?.visitorsParking
              : null
          },
          garden: data.garden ? data.garden : false,
          pool: data.pool ? data.pool : false,
          flatlet: data.flatlet ? data.flatlet : false,
          garages: data.garages ? data.garages : 0,
          petsAllowed: data.petsAllowed ? data.petsAllowed : "DontKnow",
          furnishedStatus: "No",
          numberOfFloors: data?.numberOfFloors ? data?.numberOfFloors : null,
          isWheelchairAccessible: data?.wheelchair ? data?.wheelchair : null,
          hasGenerator: data?.generator ? data?.generator : null,
          hasBackupWater: data?.backupWater ? data?.backupWater : null,
          sustainabilityInfo: {
            solarPanels: data?.solarPanels ? data?.solarPanels : false,
            solarGeyser: data?.solarGeyser ? data?.solarGeyser : false,
            gasGeyser: data?.gasGeyser ? data?.gasGeyser : false,
            waterTank: data?.waterTank ? data?.waterTank : false,
            borehole: data?.orehole ? data?.orehole : false,
            backupBatteryOrInverter: data?.backupBatteryOrInverter
              ? data?.backupBatteryOrInverter
              : false
          }
        },
        commercialInfo: {
          buildingName: data?.buildingName ? data?.buildingName : null, //No Input
          grossLettableAreaSqm: Number(data?.gla) ? Number(data?.gla) : null, //Has Input
          greenBuilding: data?.greenBuilding ? data?.greenBuilding : null, //No Input
          buildingGrade: data?.buildingGrade ? data?.buildingGrade : null, //Has Input
          multiTenanted: data?.multiTenanted ? data?.multiTenanted : null, //Has Input
          leaseType: data?.leaseType ? data?.leaseType : null, //Has input
          grossPrice: Number(data?.grossPrice)
            ? Number(data?.grossPrice)
            : null, //No input
          netPrice: data?.retailPrice ? data?.retailPrice : null, //No input
          availabilityDate:
            (data?.availableFrom && data?.availabilityOption !== "Negotiable")
              ? data?.availableFrom
              : null, //Has Input
          heightOfRoof: data?.heightOfRoof ? data?.heightOfRoof : null, //has input
          heightOfEaves: data?.heightOfEaves ? data?.heightOfEaves : null, //Has Input
          heightForRacking: data?.heightForRacking
            ? data?.heightForRacking
            : null, //Has Input
          truckAccess: data?.truckAccess ? data?.truckAccess : null,
          dockLevellers: data?.dockLevellers ? data?.dockLevellers : null,
          heightOfDockLevellers: data?.heightOfDockLevellers
            ? data?.heightOfDockLevellers
            : null,
          rollerShutterDoors: data?.rollerShutterDoors
            ? data?.rollerShutterDoors
            : null,
          heightOfRollerShutterDoors: data?.heightOfRollerShutterDoors
            ? data?.heightOfRollerShutterDoors
            : null,
          yardSpaceSqm: Number(data?.yardSize) ? Number(data?.yardSize) : null,
          yardPrice: {
            amount: data?.yardPrice ? data?.yardPrice : 0,
            unit: "PerSquareMetre"
          },
          warehouseSpaceSqm: data?.warehouseSpaceSqm
            ? data?.warehouseSpaceSqm
            : null,
          warehousePrice: {
            amount: data?.warehousePrice ? data?.warehousePrice : 0,
            unit: "PerSquareMetre"
          },
          officeToWarehouseRatio: data?.officeToWarehouseRatio
            ? data?.officeToWarehouseRatio
            : null,
          hasNaturalLight: data?.hasNaturalLight ? data?.hasNaturalLight : null,
          powerAvailability: data?.threePhasePower ? "ThreePhase" : null,
          powerDetailsDescription: data?.powerDetailsDescription
            ? data?.powerDetailsDescription
            : null,
          boardrooms: {
            boardrooms: data?.boardrooms ? data?.boardrooms : null,
            description: data?.boardroomsDescription
              ? data?.boardroomsDescription
              : null,
            furnitureIncluded: data?.furnitureIncluded
              ? data?.furnitureIncluded
              : null,
            internetPort: data?.internetPort ? data?.internetPort : null,
            tvPort: data?.tvPort ? data?.tvPort : null,
            wiFi: data?.wiFi ? data?.wiFi : null
          }
        },
        floorNumber: data?.floorNumber ? data?.floorNumber : null,
        coverage: data?.coverage ? data?.coverage : null,
        pricePerParkingBay: data?.pricePerParkingBay
          ? data?.pricePerParkingBay
          : null,
        zoneType: data?.zoneType ? data?.zoneType : null,
        tags: data?.tags ? data?.tags : [],
        featureTags: data?.featureTags ? data?.featureTags : [],
        developmentId: data?.developmentId ? data?.developmentId : null,
        lightstoneId: data?.lightstoneId ? data?.lightstoneId : null,
        repossessed: data?.repossessed ? data?.repossessed : false,
        youTubeVideoId: data?.youtubeLinkId ? data?.youtubeLinkId : null,
        matterportSpaceId: data?.matterportSpaceId
          ? data?.matterportSpaceId
          : null,
        noTransferCost:
          data?.noTransferCost === "yes"
            ? true
            : data?.noTransferCost === "no"
              ? false
              : false,
        ignoreForPriceReducedAlerts: data?.ignoreForPriceReducedAlerts
          ? data?.ignoreForPriceReducedAlerts
          : false,
        eyeSpy360Url: data?.eyeSpy360Url ? data?.eyeSpy360Url : null,
        isMultiListing: data?.isMultiListing ? data?.isMultiListing : false
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${cloud_function_server_url}/publishtoprop24PROD_GEN2`, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          if (result.errors || result.error) {
            let errorMessage = ``;

            if (result.errors) {
              errorMessage = parseApiErrors(result.errors);
            }

            if (result.error) {
              errorMessage = result.error;
            }

            dispatch({
              type: ADD_PUBLISH_FAILED,
              payload: `Sorry an error has occured ,\n ${errorMessage}`
            });
            return;
          }
          console.log("result", result);

          dispatch({
            type: ADD_PUBLISH_SUCCESS,
            payload: result
          });

          dispatch(
            api.UpdateListing({
              id: data.id,
              ListingId: result.listingNumber,
              P24expiryDate: data.P24expiryDate ? data.P24expiryDate : data.expiryDate,
              P24Status: data.P24Status ?? "NewListing",
              publishedProp24: true,
              status: "Active", //Has input
              syndicateFlags: {
                privateProperty: true,
                website: true,
                property24: true
              },
              userdetials: {
                ...data.userdetials,
                agentId: Number(agentId)
              }
            })
          );
        })
        .catch((error) => {
          console.error(error);
          dispatch({
            type: ADD_PUBLISH_FAILED,
            payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`
          });
        });
    } catch (error) {
      console.error(error);
      dispatch({
        type: ADD_PUBLISH_FAILED,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`
      });
    }
  };

export const publishto24propUpdate =
  (data, agentId) => (dispatch) => async (firebase) => {
    const { singleListingRef } = firebase;
    dispatch({
      type: ADD_PUBLISH,
      payload: false
    });

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "text/plain");
      myHeaders.append(
        "Authorization",
        "Basic ZXhkZXZAYXBpcHJvcGVydHkuY28uemE6QXByaWwyMDI0JA=="
      );
      let imageDataObject = await convertListingImagesToProp24Object(
        data.images
      );

      const raw = JSON.stringify({
        agencyId: 31335,
        contactAgentIds: [Number(agentId) ? Number(agentId) : agentId],
        listingType: "Rental",
        listingNumber: data?.ListingId,
        status: data?.status ? data?.status : "Active",
        price: Number(data?.price) ? Number(data?.price) : 0,
        isPOA: false,
        listingVisibility: data?.listingVisibility
          ? data?.listingVisibility
          : "Public",
        expiryDate: data?.expiryDate ? data?.expiryDate : "2026-03-08",
        description: data?.description ? data?.description : "",
        descriptionHeader: data?.marketingHeading ? data?.marketingHeading : "",
        showDays: [
          {
            startDate: data?.startDate ? data?.startDate : "2022-03-08",
            endDate: data?.endDate ? data?.endDate : "2022-03-08"
          }
        ],
        photos: imageDataObject,
        propertyInfo: {
          showLocation: data?.showLocation ? data?.showLocation : true,
          age: data?.age ? data?.age : 0,
          suburbId: data?.suburbId ? data?.suburbId : 455,
          municipalRatesAndTaxes: {
            amount: data?.municipalRatesAndTaxes
              ? data?.municipalRatesAndTaxes
              : 0,
            unit: data?.municipalRatesAndTaxesUnit
              ? data?.municipalRatesAndTaxesUnit
              : "PerSquareMetre"
          },
          monthlyLevy: {
            amount: Number(data?.price) ? Number(data?.price) : 0,
            unit: data?.unit ? data?.unit : "PerSquareMetre"
          },
          streetNumber: data?.streetNumber ? data?.streetNumber : "",
          streetName: data?.address.address ? data?.address.address : "",
          standNumber: data?.address.standNumber
            ? data?.address.standNumber
            : "",
          sourceReference: data?.web_Ref_No ? data?.web_Ref_No : "",
          geographicLocation: {
            longitude: data?.address?.coords.lng,
            latitude: data?.address?.coords.lat
          },
          propertyDescription: {
            propertyDescriptionType: 1,
            deedsOffice: (data?.office || "").replace(/\s+/g, ""),

            township: data?.township ? data?.township : "",
            erfNumber: Number(data?.erf) ? Number(data?.erf) : 123456,
            portion: data?.portion ? data?.portion : "",
            registrationDivision: data?.registrationDivision
              ? data?.registrationDivision
              : "",
            farmNumber: Number(data?.farmNumber)
              ? Number(data?.farmNumber)
              : 123,
            farmName: data?.farmName ? data?.farmName : "",
            holdingName: data?.holdingName ? data?.holdingName : "",
            holdingNumber: Number(data?.holdingNumber)
              ? Number(data?.holdingNumber)
              : 123,
            schemeName: data?.schemeName ? data?.schemeName : "",
            schemeNumber: Number(data?.schemeNumber)
              ? Number(data?.schemeNumber)
              : 123,
            unitNumber: data?.unitNumber ? data?.unitNumber : "",
            exclusiveUseAreaNumber: data?.exclusiveUseAreaNumber
              ? data?.exclusiveUseAreaNumber
              : ""
          },
          erf: {
            size: data?.erf?.size ? data?.erf?.size : 0,
            areaUnit: data?.erf?.areaUnit ? data?.erf?.areaUnit : "SquareMetres"
          },
          floorArea: {
            size: data?.floorSize ? data?.floorSize : 0,
            areaUnit: data?.areaUnit ? data?.areaUnit : "SquareMetres"
          },
          propertyTypeId: 12,
          specialLevy: data?.specialLevy ? data?.specialLevy : 0,
          floorNumber: data?.floorNumber ? data?.floorNumber : 0,
          coverage: data?.coverage ? data?.coverage : 0,
          pricePerParkingBay: data?.pricePerParkingBay
            ? data?.pricePerParkingBay
            : 0,
          zoneType: data?.zoneType ? data?.zoneType : "SingleResidential"
        },
        propertyFeatures: {
          bedrooms: data.bedrooms ? data.bedrooms : 0,
          bathrooms: {
            bathrooms: data.bathrooms ? data.bathrooms : 0,
            description: "",
            cleaningService: false,
            unisexBathrooms: false,
            communalBathrooms: false,
            executiveBathrooms: false,
            inUnitBathrooms: false
          },
          garages: data.garages ? data.garages : 0,
          // domesticBathrooms: data.domesticBathrooms ? data.domesticBathrooms : 0,
          // heightRestrictions: data.heightRestrictions ? data.heightRestrictions : 0,
          // receptionRooms: dat,
          // studies: 1,
          // kitchens: {
          //   kitchens: 1,
          //   description: "Makes great food",
          //   dishwasher: false,
          //   cleaningService: false,
          //   sink: true,
          //   coffeeMachine: false
          // },
          parking: {
            parkingSpaces: data?.parkingSpaces ? data?.parkingSpaces : 0,
            parkingSpacesDescription: data?.parkingSpacesDescription
              ? data?.parkingSpacesDescription
              : "",
            parkingBayNumber: data?.parkingBayNumber
              ? data?.parkingBayNumber
              : "A1",
            carport: data?.carport ? data?.carport : false,
            doubleParking: data?.doubleParking ? data?.doubleParking : false,
            onStreetParking: data?.onStreetParking
              ? data?.onStreetParking
              : false,
            secureParking: data?.secureParking ? data?.secureParking : false,
            shadeNetCoveredParking: data?.shadeNetCoveredParking
              ? data?.shadeNetCoveredParking
              : false,
            singleParking: data?.singleParking ? data?.singleParking : false,
            tandemParking: data?.tandemParking ? data?.tandemParking : false,
            tripleParking: data?.tripleParking ? data?.tripleParking : false,
            undergroundParking: data?.undergroundParking
              ? data?.undergroundParking
              : false,
            visitorsParking: data?.visitorsParking
              ? data?.visitorsParking
              : false
          },
          // domesticRooms: 1,
          // outsideToilets: 1,
          garden: data.garden ? data.garden : false,
          pool: data.pool ? data.pool : false,
          flatlet: data.flatlet ? data.flatlet : false,
          // secondHouse: false,
          // outBuildingsSize: 40,
          // bedroomsDescription: "Large bedrooms with BIC",
          // domesticRoomsDescription: "Contains toilet and shower.",
          // flatDescription: "Bachelor flatlet",
          // garagesDescription: "Large tandem garage",
          // poolDescription: "Saltwater pool with water feature",
          // receptionRoomsDescription: "Tiled and open plan",
          // studiesDescription: "Spacious with ceiling fan.",
          petsAllowed: data.petsAllowed ? data.petsAllowed : "DontKnow",
          furnishedStatus: "No",
          // hasStandaloneBuilding: true,
          numberOfFloors: data?.numberOfFloors ? data?.numberOfFloors : 1,
          // publicTransport: {
          //   nearbyBusService: true,
          //   nearbyMinibusTaxiService: false,
          //   nearbyTrainService: true
          // },
          // internetAccess: {
          //   adsl: true,
          //   dialUp: false,
          //   fibre: true,
          //   fixedWiMax: false,
          //   isdn: false,
          //   satellite: true,
          //   vdsl: false
          // },
          isWheelchairAccessible: data?.wheelchair ? data?.wheelchair : false,
          hasGenerator: data?.generator ? data?.generator : false,
          hasBackupWater: data?.backupWater ? data?.backupWater : false,
          // outsideArea: {
          //   outsideAreas: 1,
          //   description: "Well-maintained lawn",
          //   balcony: false,
          //   courtyard: false,
          //   roofArea: false
          // },
          sustainabilityInfo: {
            solarPanels: data?.solarPanels ? data?.solarPanels : false,
            solarGeyser: data?.solarGeyser ? data?.solarGeyser : false,
            gasGeyser: data?.gasGeyser ? data?.gasGeyser : false,
            waterTank: data?.waterTank ? data?.waterTank : false,
            borehole: data?.orehole ? data?.orehole : false,
            backupBatteryOrInverter: data?.backupBatteryOrInverter
              ? data?.backupBatteryOrInverter
              : false
          }
        },
        rentalInfo: {
          rentalRate: "Month",
          leasePeriod: "12 Months"
        },
        // complexInfo: {
        //   complexName: "Awesome Towers",
        //   unitName: "The Loft",
        //   unitNumber: "1B"
        // },
        // auctionInfo: {
        //   date: "2022-06-15",
        //   venue: "Town Hall",
        //   description: "Auction description",
        //   numberOfLots: 10
        // },
        commercialInfo: {
          buildingName: data?.buildingName ? data?.buildingName : "",
          grossLettableAreaSqm: Number(data?.gla) ? Number(data?.gla) : 0,
          greenBuilding: data?.greenBuilding ? data?.greenBuilding : false,
          buildingGrade: data?.buildingGrade ? data?.buildingGrade : "P",
          multiTenanted: data?.multiTenanted ? data?.multiTenanted : false,
          leaseType: data?.leaseType ? data?.leaseType : "Percentage",
          grossPrice: Number(data?.grossPrice) ? Number(data?.grossPrice) : 0,
          netPrice: data?.retailPrice ? data?.retailPrice : 0,
          availabilityDate: data?.availabilityDate
            ? data?.availabilityDate
            : "2025-01-08",
          heightOfRoof: data?.heightOfRoof ? data?.heightOfRoof : 0,
          heightOfEaves: data?.heightOfEaves ? data?.heightOfEaves : 0,
          heightForRacking: data?.heightForRacking ? data?.heightForRacking : 0,
          truckAccess: data?.truckAccess ? data?.truckAccess : "None",
          dockLevellers: data?.dockLevellers ? data?.dockLevellers : 1,
          heightOfDockLevellers: data?.heightOfDockLevellers
            ? data?.heightOfDockLevellers
            : 0,
          rollerShutterDoors: data?.rollerShutterDoors
            ? data?.rollerShutterDoors
            : 1,
          heightOfRollerShutterDoors: data?.heightOfRollerShutterDoors
            ? data?.heightOfRollerShutterDoors
            : 0,
          yardSpaceSqm: Number(data?.yardSize) ? Number(data?.yardSize) : 0,
          yardPrice: {
            amount: data?.yardPrice ? data?.yardPrice : 0,
            unit: "PerSquareMetre"
          },
          warehouseSpaceSqm: data?.warehouseSpaceSqm
            ? data?.warehouseSpaceSqm
            : 0,
          warehousePrice: {
            amount: data?.warehousePrice ? data?.warehousePrice : 0,
            unit: "PerSquareMetre"
          },
          officeToWarehouseRatio: data?.officeToWarehouseRatio
            ? data?.officeToWarehouseRatio
            : 0,
          hasNaturalLight: data?.hasNaturalLight
            ? data?.hasNaturalLight
            : false,
          powerAvailability: data?.powerAvailability
            ? data?.powerAvailability
            : "SinglePhase",
          powerDetailsDescription: data?.powerDetailsDescription
            ? data?.powerDetailsDescription
            : "",
          boardrooms: {
            boardrooms: data?.boardrooms ? data?.boardrooms : 0,
            description: data?.boardroomsDescription
              ? data?.boardroomsDescription
              : "",
            furnitureIncluded: data?.furnitureIncluded
              ? data?.furnitureIncluded
              : false,
            internetPort: data?.internetPort ? data?.internetPort : false,
            tvPort: data?.tvPort ? data?.tvPort : false,
            wiFi: data?.wiFi ? data?.wiFi : false
          }
        },
        erf: {
          size: data?.erf?.size ? data?.erf?.size : 0,
          areaUnit: data?.erf?.areaUnit ? data?.erf?.areaUnit : "SquareMetres"
        },
        floorArea: {
          size: data?.floorSize ? data?.floorSize : 0,
          areaUnit: data?.areaUnit ? data?.areaUnit : "SquareMetres"
        },
        propertyTypeId: 12,
        specialLevy: data?.specialLevy ? data?.specialLevy : 0,
        floorNumber: data?.floorNumber ? data?.floorNumber : 0,
        coverage: data?.coverage ? data?.coverage : 0,
        pricePerParkingBay: data?.pricePerParkingBay
          ? data?.pricePerParkingBay
          : 0,
        zoneType: data?.zoneType ? data?.zoneType : "SingleResidential",

        propertyFeatures: {
          bedrooms: data.bedrooms ? data.bedrooms : 0,
          bathrooms: {
            bathrooms: data.bathrooms ? data.bathrooms : 0,
            description: "",
            cleaningService: false,
            unisexBathrooms: false,
            communalBathrooms: false,
            executiveBathrooms: false,
            inUnitBathrooms: false
          },
          garages: data.garages ? data.garages : 0,
          // domesticBathrooms: data.domesticBathrooms ? data.domesticBathrooms : 0,
          // heightRestrictions: data.heightRestrictions ? data.heightRestrictions : 0,
          // receptionRooms: dat,
          // studies: 1,
          // kitchens: {
          //   kitchens: 1,
          //   description: "Makes great food",
          //   dishwasher: false,
          //   cleaningService: false,
          //   sink: true,
          //   coffeeMachine: false
          // },
          parking: {
            parkingSpaces: data?.parkingSpaces ? data?.parkingSpaces : 0,
            parkingSpacesDescription: data?.parkingSpacesDescription
              ? data?.parkingSpacesDescription
              : "",
            parkingBayNumber: data?.parkingBayNumber
              ? data?.parkingBayNumber
              : "A1",
            carport: data?.carport ? data?.carport : false,
            doubleParking: data?.doubleParking ? data?.doubleParking : false,
            onStreetParking: data?.onStreetParking
              ? data?.onStreetParking
              : false,
            secureParking: data?.secureParking ? data?.secureParking : false,
            shadeNetCoveredParking: data?.shadeNetCoveredParking
              ? data?.shadeNetCoveredParking
              : false,
            singleParking: data?.singleParking ? data?.singleParking : false,
            tandemParking: data?.tandemParking ? data?.tandemParking : false,
            tripleParking: data?.tripleParking ? data?.tripleParking : false,
            undergroundParking: data?.undergroundParking
              ? data?.undergroundParking
              : false,
            visitorsParking: data?.visitorsParking
              ? data?.visitorsParking
              : false
          },
          // domesticRooms: 1,
          // outsideToilets: 1,
          garden: data.garden ? data.garden : false,
          pool: data.pool ? data.pool : false,
          flatlet: data.flatlet ? data.flatlet : false,
          // secondHouse: false,
          // outBuildingsSize: 40,
          // bedroomsDescription: "Large bedrooms with BIC",
          // domesticRoomsDescription: "Contains toilet and shower.",
          // flatDescription: "Bachelor flatlet",
          // garagesDescription: "Large tandem garage",
          // poolDescription: "Saltwater pool with water feature",
          // receptionRoomsDescription: "Tiled and open plan",
          // studiesDescription: "Spacious with ceiling fan.",
          petsAllowed: data.petsAllowed ? data.petsAllowed : "DontKnow",
          furnishedStatus: "No",
          // hasStandaloneBuilding: true,
          numberOfFloors: data?.numberOfFloors ? data?.numberOfFloors : 1,
          // publicTransport: {
          //   nearbyBusService: true,
          //   nearbyMinibusTaxiService: false,
          //   nearbyTrainService: true
          // },
          // internetAccess: {
          //   adsl: true,
          //   dialUp: false,
          //   fibre: true,
          //   fixedWiMax: false,
          //   isdn: false,
          //   satellite: true,
          //   vdsl: false
          // },
          isWheelchairAccessible: data?.wheelchair ? data?.wheelchair : false,
          hasGenerator: data?.generator ? data?.generator : false,
          hasBackupWater: data?.backupWater ? data?.backupWater : false,
          // outsideArea: {
          //   outsideAreas: 1,
          //   description: "Well-maintained lawn",
          //   balcony: false,
          //   courtyard: false,
          //   roofArea: false
          // },
          sustainabilityInfo: {
            solarPanels: data?.solarPanels ? data?.solarPanels : false,
            solarGeyser: data?.solarGeyser ? data?.solarGeyser : false,
            gasGeyser: data?.gasGeyser ? data?.gasGeyser : false,
            waterTank: data?.waterTank ? data?.waterTank : false,
            borehole: data?.orehole ? data?.orehole : false,
            backupBatteryOrInverter: data?.backupBatteryOrInverter
              ? data?.backupBatteryOrInverter
              : false
          }
        },
        rentalInfo: {
          rentalRate: "Month",
          depositRequirementsComments: "Equal to one month's rent",
          leasePeriod: "12 Months"
        },
        // complexInfo: {
        //   complexName: "Awesome Towers",
        //   unitName: "The Loft",
        //   unitNumber: "1B"
        // },
        // auctionInfo: {
        //   date: "2022-06-15",
        //   venue: "Town Hall",
        //   description: "Auction description",
        //   numberOfLots: 10
        // },
        commercialInfo: {
          buildingName: data?.buildingName ? data?.buildingName : "",
          grossLettableAreaSqm: Number(data?.gla) ? Number(data?.gla) : 0,
          greenBuilding: data?.greenBuilding ? data?.greenBuilding : false,
          buildingGrade: data?.buildingGrade ? data?.buildingGrade : "P",
          multiTenanted: data?.multiTenanted ? data?.multiTenanted : false,
          leaseType: data?.leaseType ? data?.leaseType : "Percentage",
          grossPrice: Number(data?.grossPrice) ? Number(data?.grossPrice) : 0,
          netPrice: Number(data?.price) ? Number(data?.price) : 0,
          availabilityDate: data?.availabilityDate
            ? data?.availabilityDate
            : "2025-10-02",
          heightOfRoof: data?.heightOfRoof ? data?.heightOfRoof : 0,
          heightOfEaves: data?.heightOfEaves ? data?.heightOfEaves : 0,
          heightForRacking: data?.heightForRacking ? data?.heightForRacking : 0,
          truckAccess: data?.truckAccess ? data?.truckAccess : "None",
          dockLevellers: data?.dockLevellers ? data?.dockLevellers : 1,
          heightOfDockLevellers: data?.heightOfDockLevellers
            ? data?.heightOfDockLevellers
            : 0,
          rollerShutterDoors: data?.rollerShutterDoors
            ? data?.rollerShutterDoors
            : 1,
          heightOfRollerShutterDoors: data?.heightOfRollerShutterDoors
            ? data?.heightOfRollerShutterDoors
            : 0,
          yardSpaceSqm: Number(data?.yardSize) ? Number(data?.yardSize) : 0,
          yardPrice: {
            amount: data?.yardPrice ? data?.yardPrice : 0,
            unit: "PerSquareMetre"
          },
          warehouseSpaceSqm: data?.warehouseSpaceSqm
            ? data?.warehouseSpaceSqm
            : 0,
          warehousePrice: {
            amount: data?.warehousePrice ? data?.warehousePrice : 0,
            unit: "PerSquareMetre"
          },
          officeToWarehouseRatio: data?.officeToWarehouseRatio
            ? data?.officeToWarehouseRatio
            : 0,
          hasNaturalLight: data?.hasNaturalLight
            ? data?.hasNaturalLight
            : false,
          powerAvailability: data?.powerAvailability
            ? data?.powerAvailability
            : "SinglePhase",
          powerDetailsDescription: data?.powerDetailsDescription
            ? data?.powerDetailsDescription
            : "",
          boardrooms: {
            boardrooms: data?.boardrooms ? data?.boardrooms : 0,
            description: data?.boardroomsDescription
              ? data?.boardroomsDescription
              : "",
            furnitureIncluded: data?.furnitureIncluded
              ? data?.furnitureIncluded
              : false,
            internetPort: data?.internetPort ? data?.internetPort : false,
            tvPort: data?.tvPort ? data?.tvPort : false,
            wiFi: data?.wiFi ? data?.wiFi : false
          }
        },
        tags: data?.tags ? data?.tags : [],
        featureTags: data?.featureTags ? data?.featureTags : [],
        developmentId: data?.developmentId ? data?.developmentId : 143,
        lightstoneId: data?.lightstoneId ? data?.lightstoneId : 0,
        repossessed: data?.repossessed ? data?.repossessed : false,
        youTubeVideoId: data?.youTubeVideoId ? data?.youTubeVideoId : "",
        matterportSpaceId: data?.matterportSpaceId
          ? data?.matterportSpaceId
          : "",
        noTransferCost:
          data?.noTransferCost === "yes"
            ? true
            : data?.noTransferCost === "no"
              ? false
              : false,
        ignoreForPriceReducedAlerts: data?.ignoreForPriceReducedAlerts
          ? data?.ignoreForPriceReducedAlerts
          : false,
        eyeSpy360Url: data?.eyeSpy360Url ? data?.eyeSpy360Url : "",
        isMultiListing: data?.isMultiListing ? data?.isMultiListing : false
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${cloud_function_server_url}/publishtoprop24`, requestOptions)
        .then((response) => {
          let payload = response.json();

          return payload;
        })
        .then((result) => {
          dispatch({
            type: ADD_PUBLISH_SUCCESS,
            payload: result
          });

          dispatch(
            api.UpdateListing({
              ListingId: result.listingNumber,
              publishedProp24: true
            })
          );
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
      dispatch({
        type: ADD_PUBLISH_FAILED,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`
      });
    }
  };

// syncTop24 action
export const syncTop24 =
  (listing, agentId) => (dispatch) => async (firebase) => {
    dispatch({ type: SYNC_TO_PROP24, payload: false });

    try {
      const { singleListingRef, api } = firebase;

      if (listing?.ListingId) {
        // Convert images to Property24 format (reuse your existing function)
        let imageDataObject = await convertListingImagesToProp24Object(
          listing.images
        );

        // Prepare complete sync data with ALL necessary fields
        const syncData = {
          agencyId: 31335,
          contactAgentIds: [Number(agentId) ? Number(agentId) : agentId],
          listingType:
            listing.type === "tolet" || listing.type.includes("To Let")
              ? "Rental"
              : "Sale",
          listingNumber: listing?.ListingId || null, // For updates
          status: listing?.status || "Active",
          price:
            listing.type === "tolet" || listing.type.includes("To Let")
              ? Number(listing?.grossmonthlyRental)
              : Number(listing.price),
          isPOA: listing?.isPOA || false,
          listingVisibility: listing?.listingVisibility || "Public",
          occupationDate: listing?.occupationDate || "2025-01-08",
          expiryDate: listing?.expiryDate || "2026-03-08",
          description: listing?.description || "",
          descriptionHeader: listing?.marketingHeading || "",

          showDays: [
            {
              startDate: listing?.startDate || "2022-03-08",
              endDate: listing?.endDate || "2022-03-08"
            }
          ],

          photos: imageDataObject,

          propertyInfo: {
            showLocation: listing?.showLocation || true,
            age: listing?.age || 0,
            suburbId: listing?.suburbId || 455,

            municipalRatesAndTaxes: {
              amount: listing?.municipalRatesAndTaxes || 0,
              unit: listing?.municipalRatesAndTaxesUnit || "PerSquareMetre"
            },

            monthlyLevy: {
              amount: Number(listing?.price) || 0,
              unit: listing?.unit || "PerSquareMetre"
            },

            streetNumber: listing?.streetNumber || "",
            streetName: listing?.address?.address || "",
            standNumber: listing?.address?.standNumber || "",
            sourceReference: listing?.web_Ref_No || "",

            geographicLocation: {
              longitude: listing?.address?.coords?.lng,
              latitude: listing?.address?.coords?.lat
            },

            propertyDescription: {
              propertyDescriptionType: 1,
              deedsOffice: (listing?.office || "").replace(/\s+/g, ""),
              township: listing?.township || "",
              erfNumber: Number(listing?.erf) || 123456,
              portion: listing?.portion || "",
              registrationDivision: listing?.registrationDivision || "",
              farmNumber: Number(listing?.farmNumber) || 123,
              farmName: listing?.farmName || "",
              holdingName: listing?.holdingName || "",
              holdingNumber: Number(listing?.holdingNumber) || 123,
              schemeName: listing?.schemeName || "",
              schemeNumber: Number(listing?.schemeNumber) || 123,
              unitNumber: listing?.unitNumber || "",
              exclusiveUseAreaNumber: listing?.exclusiveUseAreaNumber || ""
            },

            erf: {
              size: listing?.erf?.size || 0,
              areaUnit: listing?.erf?.areaUnit || "SquareMetres"
            },

            floorArea: {
              size: listing?.floorSize || 0,
              areaUnit: listing?.areaUnit || "SquareMetres"
            },

            propertyTypeId: 12,
            specialLevy: listing?.specialLevy || 0,
            floorNumber: listing?.floorNumber || 0,
            coverage: listing?.coverage || 0,
            pricePerParkingBay: listing?.pricePerParkingBay || 0,
            zoneType: listing?.zoneType || "SingleResidential"
          },

          propertyFeatures: {
            bedrooms: listing.bedrooms || 0,

            bathrooms: {
              bathrooms: listing.bathrooms || 0,
              description: "",
              cleaningService: false,
              unisexBathrooms: false,
              communalBathrooms: false,
              executiveBathrooms: false,
              inUnitBathrooms: false
            },

            garages: listing.garages || 0,

            parking: {
              parkingSpaces: listing?.parkingSpaces || 0,
              parkingSpacesDescription: listing?.parkingSpacesDescription || "",
              parkingBayNumber: listing?.parkingBayNumber || "A1",
              carport: listing?.carport || false,
              doubleParking: listing?.doubleParking || false,
              onStreetParking: listing?.onStreetParking || false,
              secureParking: listing?.secureParking || false,
              shadeNetCoveredParking: listing?.shadeNetCoveredParking || false,
              singleParking: listing?.singleParking || false,
              tandemParking: listing?.tandemParking || false,
              tripleParking: listing?.tripleParking || false,
              undergroundParking: listing?.undergroundParking || false,
              visitorsParking: listing?.visitorsParking || false
            },

            garden: listing.garden || false,
            pool: listing.pool || false,
            flatlet: listing.flatlet || false,
            petsAllowed: listing.petsAllowed || "DontKnow",
            furnishedStatus: "No",
            numberOfFloors: listing?.numberOfFloors || 1,
            isWheelchairAccessible: listing?.wheelchair || false,
            hasGenerator: listing?.generator || false,
            hasBackupWater: listing?.backupWater || false,

            sustainabilityInfo: {
              solarPanels: listing?.solarPanels || false,
              solarGeyser: listing?.solarGeyser || false,
              gasGeyser: listing?.gasGeyser || false,
              waterTank: listing?.waterTank || false,
              borehole: listing?.orehole || false,
              backupBatteryOrInverter: listing?.backupBatteryOrInverter || false
            }
          },

          rentalInfo: {
            rentalRate: "Month",
            depositRequirementsComments: "Equal to one month's rent",
            leasePeriod: "12 Months"
          },

          commercialInfo: {
            buildingName: listing?.buildingName || "",
            grossLettableAreaSqm: Number(listing?.gla) || 0,
            greenBuilding: listing?.greenBuilding || false,
            buildingGrade: listing?.buildingGrade || "P",
            multiTenanted: listing?.multiTenanted || false,
            leaseType: listing?.leaseType || "Percentage",
            grossPrice: Number(listing?.grossPrice) || 0,
            netPrice: listing?.retailPrice || 0,
            availabilityDate: listing?.availabilityDate || "2025-01-08",
            heightOfRoof: listing?.heightOfRoof || 0,
            heightOfEaves: listing?.heightOfEaves || 0,
            heightForRacking: listing?.heightForRacking || 0,
            truckAccess: listing?.truckAccess || "None",
            dockLevellers: listing?.dockLevellers || 1,
            heightOfDockLevellers: listing?.heightOfDockLevellers || 0,
            rollerShutterDoors: listing?.rollerShutterDoors || 1,
            heightOfRollerShutterDoors:
              listing?.heightOfRollerShutterDoors || 0,
            yardSpaceSqm: Number(listing?.yardSize) || 0,

            yardPrice: {
              amount: listing?.yardPrice || 0,
              unit: "PerSquareMetre"
            },

            warehouseSpaceSqm: listing?.warehouseSpaceSqm || 0,

            warehousePrice: {
              amount: listing?.warehousePrice || 0,
              unit: "PerSquareMetre"
            },

            officeToWarehouseRatio: listing?.officeToWarehouseRatio || 0,
            hasNaturalLight: listing?.hasNaturalLight || false,
            powerAvailability: listing?.powerAvailability || "SinglePhase",
            powerDetailsDescription: listing?.powerDetailsDescription || "",

            boardrooms: {
              boardrooms: listing?.boardrooms || 0,
              description: listing?.boardroomsDescription || "",
              furnitureIncluded: listing?.furnitureIncluded || false,
              internetPort: listing?.internetPort || false,
              tvPort: listing?.tvPort || false,
              wiFi: listing?.wiFi || false
            }
          },

          tags: listing?.tags || [],
          featureTags: listing?.featureTags || [],
          developmentId: listing?.developmentId || 143,
          lightstoneId: listing?.lightstoneId || 0,
          repossessed: listing?.repossessed || false,
          youTubeVideoId: listing?.youTubeVideoId || "",
          matterportSpaceId: listing?.matterportSpaceId || "",

          noTransferCost:
            listing?.noTransferCost === "yes"
              ? true
              : listing?.noTransferCost === "no"
                ? false
                : false,

          ignoreForPriceReducedAlerts:
            listing?.ignoreForPriceReducedAlerts || false,
          eyeSpy360Url: listing?.eyeSpy360Url || "",
          isMultiListing: listing?.isMultiListing || false
        };

        // Call your backend endpoint
        const response = await fetch(
          `${cloud_function_server_url}/publishtoprop24`,
          {
            //this need to be set correctly
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(syncData)
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // Update Firebase with sync status
        const updates = {
          lastSyncedProp24: new Date().toISOString(),
          syncStatusProp24: "success",
          lastSyncError: null,
          id: listing.id,
          syndicateFlags: {
            property24: true
          }
        };

        // If this was a new listing, save the ListingId
        if (result.listingNumber && !listing.ListingId) {
          updates.ListingId = result.listingNumber;
        }

        dispatch(api.UpdateListing(updates));

        dispatch({
          type: SYNC_TO_PROP24_SUCCESS,
          payload: {
            ...result,
            timestamp: new Date().toISOString()
          }
        });
      } else {
        dispatch({
          type: SYNC_TO_PROP24_FAILED,
          payload:
            "No Listing Id found Please ensure this listing is published before trying to sync"
        });
      }
    } catch (error) {
      console.error("Property24 sync error:", error);

      // Update Firebase with error status
      if (firebase && firebase.singleListingRef) {
        await firebase.singleListingRef(listing.id).update({
          lastSyncAttemptProp24: new Date().toISOString(),
          syncStatusProp24: "failed",
          lastSyncError: error.message
        });
      }

      dispatch({
        type: SYNC_TO_PROP24_FAILED,
        payload: error.message
      });
    }
  };

// Similarly complete implementations for the other portals:

export const syncToPP =
  (listing) =>
    async (dispatch, getState, { firebase }) => {
      dispatch({ type: SYNC_TO_PRIVATEPROP, payload: false });

      try {
        const { singleListingRef } = firebase;

        // Prepare Private Property data (reuse your existing structure from publishToprivateprop)
        const syncData = {
          PropertyId: listing.id,
          BranchId: "557743A302EB48A19D67FE9BECDCA84F",
          Category: { Category: listing.category || "" },
          MandateType: listing.mandateType || "",
          StreetName: listing.streetName || "",
          StreetNumber: listing.streetNumber || "",
          ComplexName: listing.complexName || "",
          UnitNumber: listing.unitNumber || "",
          Suburb: listing.suburb || "",
          Town: listing.town || "",
          Province: listing.province || "",
          Description: listing.description || "",
          Price: listing.price || 0,
          ListingDate: listing.listingDate || new Date().toISOString(),
          ExpiryDate:
            listing.expiryDate ||
            new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
          AvailableFrom: listing.availableFrom || "",
          AgentId: listing.agentId || "",
          PhotoUrls: { string: listing.images?.Image0 || "" },
          ListingType: listing.listingType || "",
          PropertyStatus: listing.type || "",
          // Include all other attributes from your existing implementation
          Attributes: {
            Attribute: [
              {
                AttributeType: listing.attributeType || "",
                Value: listing.attributeType || ""
              }
              // Include all other attributes...
            ]
          },
          HideStreetName: listing.hideStreetName || false,
          HideStreetNo: listing.hideStreetNo || false,
          HideComplexName: listing.hideComplexName || false,
          HideUnitNumber: listing.hideUnitNumber || false
        };

        const response = await fetch(
          `${cloud_function_server_url}/publishtoPrivateprop`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(syncData)
          }
        );

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();

        await singleListingRef(listing.id).update({
          lastSyncedPP: new Date().toISOString(),
          syncStatusPP: "success",
          lastSyncError: null
        });

        dispatch({ type: SYNC_TO_PRIVATEPROP_SUCCESS, payload: result });
      } catch (error) {
        console.error("Private Property sync error:", error);

        if (firebase && firebase.singleListingRef) {
          await firebase.singleListingRef(listing.id).update({
            lastSyncAttemptPP: new Date().toISOString(),
            syncStatusPP: "failed",
            lastSyncError: error.message
          });
        }

        dispatch({ type: SYNC_TO_PRIVATEPROP_FAILED, payload: error.message });
      }
    };

export const syncToWebsite =
  (listing) =>
    async (dispatch, getState, { firebase }) => {
      dispatch({ type: SYNC_TO_WEBSITE, payload: false });

      try {
        const { singleListingRef } = firebase;

        // Prepare website data (reuse your existing structure from publishToWeb)
        const syncData = {
          alias: listing?.web_Ref_No || listing?.web_Ref_No,
          catid: Number(listing?.catId) || 21,
          "created-by": listing?.created_by || 102,
          title: listing?.title || listing?.marketingHeading,
          articletext: listing?.description || "",
          language: listing?.language || "*",
          text: listing?.text || listing?.description,
          "security-information": listing?.security_information || "",
          "address-info": listing?.address_info || "",
          address: listing?.address?.address || "",
          "air-condition": listing?.airCondition || false,
          "listing-type": listing?.type?.data || listing?.type || "",
          "sole-mandate": listing?.typeOfMandate || "",
          freestanding: listing?.freestanding || false,
          zoning: listing?.zoning || "",
          "lease-period": listing?.leasePeriod || "Negotiable",
          "available-from": listing?.availableFrom || "",
          "available-from-date": listing?.availableFromDate || "",
          "mandate-type": listing?.typeOfMandate || "",
          "marketing-heading": listing?.marketingHeading || listing?.title,
          description: listing?.description || "",
          state: listing?.state || 1,
          status: listing?.status || "Active",
          branch: listing?.office || "",
          "private-prop": listing?.privateProp || false,
          "physical-address": listing?.address?.description || "",
          "property-location":
            listing?.address?.description || "Cape Town, South Africa",
          "image-count": listing?.imageCount,
          "commercial-property": listing?.commercialProperty || false,
          capx: listing?.capx || false,
          "qwengo-infor": listing?.qwengoInfor || "",
          "position-map-x": (listing?.address?.coords?.lat || "").toString(),
          "position-map-y": (listing?.address?.coords?.lng || "").toString(),
          "rental-price": listing?.retailPrice || 0,
          "opening-parking-bays": listing?.openingParkingBays || "",
          "covered-parking": listing?.coveredParking || "",
          "alternative-power-supply": listing?.alternativePowerSupply || "None",
          "property-type": listing?.typeOfProperty || "",
          "agent-1":
            listing?.userdetials?.Name + " " + listing?.userdetials?.lastName,
          phase: listing?.phase,
          "power-amps": listing?.powerAmps || "",
          "video-id": listing?.videoId || "",
          "normal-parking": listing?.normalParking || "",
          "size-of-land": listing?.gla || "",
          "floor-size": listing?.floorSize || "",
          "building-height": listing?.buildingHieght || "0",
          "floor-loading-capacity": listing?.floorLoadingCapacity || "",
          "office-space-size": listing?.officeSize || "",
          "virtual-tour": listing?.virtualTour || "",
          "office-space-total-cost": listing?.officePrice || "",
          "retail-size": listing?.retailSize || "",
          "warehouse-size": listing?.warehouseSize || "",
          "factory-warehouse-price": listing?.factoryWarehousePrice || "",
          "factory-warehouse-total-cost": listing?.factoryWarehouseTotalCost,
          "yard-size": listing?.yardSize || "",
          "yard-price-infor": listing?.yardPriceInfor || "",
          "seller-postal-address": listing?.seller?.postalAddress || "",
          "yard-total-cost": listing?.yardPrice || "",
          "property-size-total-cost": listing?.valuationPrice || "",
          "municipal-value": listing?.municipalValue || "",
          "gross-monthly-rental": listing?.grossmonthlyRental || "",
          "vat-number": listing?.seller?.vatNumber || "",
          "entity-postal-address": listing?.location || "",
          "eyespy360-url": listing?.eyespy360Url || "",
          offers: listing?.offers || "",
          "sale-price": listing?.price || "",
          "building-size": listing?.buildingSize || "0",
          "offer-status": listing?.offerStatus || "",
          "offers-from": listing?.offersFrom || "",
          "offers-increment": listing?.offersIncrement || "",
          "matterport-id": listing?.matterportId || "",
          "availibility-of-amps": listing?.availibilityOfAmps || "",
          "amount-of-roller-shutter-doors":
            listing?.amountOfRollerShutterDoors || "",
          "eaves-height": listing?.eavesHeight || "",
          "fire-systems": listing?.fireSystems || "",
          "alternative-water-supply": listing?.alternativeWaterSupply || "",
          publish_up: listing?.startPublishing || "",
          publish_down: listing?.finishPublishing || "",
          webref: listing?.web_Ref_No || ""
        };

        const response = await fetch(
          `${cloud_function_server_url}/publishtoapiweb`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(syncData)
          }
        );

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const result = await response.json();

        await singleListingRef(listing.id).update({
          lastSyncedWebsite: new Date().toISOString(),
          syncStatusWebsite: "success",
          lastSyncError: null,
          publishedAPIWeb: true,
          webSet: result
        });

        dispatch({ type: SYNC_TO_WEBSITE_SUCCESS, payload: result });
      } catch (error) {
        console.error("Website sync error:", error);

        if (firebase && firebase.singleListingRef) {
          await firebase.singleListingRef(listing.id).update({
            lastSyncAttemptWebsite: new Date().toISOString(),
            syncStatusWebsite: "failed",
            lastSyncError: error.message
          });
        }

        dispatch({ type: SYNC_TO_WEBSITE_FAILED, payload: error.message });
      }
    };
